<script>
import { imgHost2 } from "@/config/index";


export default {
  props: {
    rates: {
      type: Array,
      default: () => [0, 100]
    }
  },
  data () {
    return {
      imgHost2,
      min: 0,
      max: 100,
      left: '',
      range: 0,
      valRange: 0,
      lineWidth: ''
    };
  },
  onMounted () {
    this.left = `${((this.rates[0] - (this.rates[0] - 50 > 0 ? this.rates[0] - 50 : 0))
      / (this.rates[1] + 50 - (this.rates[0] - 50 > 0 ? this.rates[0] - 50 : 0)))
      * 100
      }%`
    this.min = this.rates[0] - 50 > 0 ? this.rates[0] - 50 : 0
    this.max = this.rates[1] + 50
    this.range = this.rates[1] + 50 - (this.rates[0] - 50 > 0 ? this.rates[0] - 50 : 0)
    this.valRange = this.rates[1] - this.rates[0]
    this.lineWidth = `${((this.rates[1] - this.rates[0])
      / (this.rates[1] + 50 - (this.rates[0] - 50 > 0 ? this.rates[0] - 50 : 0)))
      * 100
      }%`
  }
}
</script>


<template>
  <div>
    <div class="slider_cell">
      <div class="slider_bg">
        <div class="slider_a" :style="{
          width: rates[0] >= 999 ? '94%' : lineWidth,
          left: rates[0] >= 999 ? '2%' : left,
          backgroundColor: rates[0] >= 999 ? '#EE3F3F' : '#6883FB',
        }">
          <p class="slider_l" :style="{ left: rates[0] >= 999 ? '-20px' : '-40px;' }">
            {{ rates[0] / 10 }}%
          </p>
          <p class="slider_r" :style="{ right: rates[0] >= 999 ? '-10px' : '-45px;' }">
            {{ rates[1] / 10 }}%
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.slider_bg {
  position: relative;
  width: 100%;
  height: 5px;
  border-radius: 20px;
  background-color: rgb(212, 217, 234);
}

.slider_a {
  position: relative;
  top: 0;
  /* left: 0; */
  width: 10%;
  height: 5px;
  border-radius: 20px;
  background-color: #6883fb;
}

.slider_l {
  position: absolute;
  top: 4px;
  left: -40px;
  font-size: 16px;
  color: #3b4549;
}

.slider_r {
  position: absolute;
  top: 4px;
  right: -45px;
  font-size: 16px;
  color: #3b4549;
}
</style>
